var _rect, _rect2, _rect3, _rect4, _path, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 24,
    viewBox: "0 0 63 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 23,
    rx: 3.5,
    fill: "#272727"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 11 7)",
    fill: "#64C3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 17 7)",
    fill: "#909090"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 23 7)",
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.652 14.824H34.332V16H28.248V7.6H29.652V14.824ZM39.0051 16.156C37.6691 16.156 36.6891 15.808 36.0651 15.112C35.4411 14.416 35.1291 13.308 35.1291 11.788C35.1291 10.268 35.4491 9.164 36.0891 8.476C36.7291 7.788 37.7011 7.444 39.0051 7.444C39.6851 7.444 40.2691 7.528 40.7571 7.696C41.2531 7.864 41.6571 8.128 41.9691 8.488C42.2891 8.84 42.5211 9.292 42.6651 9.844C42.8171 10.388 42.8931 11.036 42.8931 11.788C42.8931 13.308 42.5691 14.416 41.9211 15.112C41.2811 15.808 40.3091 16.156 39.0051 16.156ZM39.0051 8.584C38.5971 8.584 38.2371 8.636 37.9251 8.74C37.6211 8.844 37.3651 9.02 37.1571 9.268C36.9491 9.508 36.7931 9.836 36.6891 10.252C36.5851 10.66 36.5331 11.176 36.5331 11.8C36.5331 12.408 36.5851 12.92 36.6891 13.336C36.7931 13.744 36.9491 14.072 37.1571 14.32C37.3651 14.568 37.6211 14.748 37.9251 14.86C38.2371 14.964 38.5971 15.016 39.0051 15.016C39.4131 15.016 39.7691 14.964 40.0731 14.86C40.3851 14.756 40.6451 14.58 40.8531 14.332C41.0611 14.076 41.2171 13.744 41.3211 13.336C41.4251 12.92 41.4771 12.4 41.4771 11.776C41.4771 11.176 41.4251 10.672 41.3211 10.264C41.2171 9.856 41.0611 9.528 40.8531 9.28C40.6451 9.032 40.3851 8.856 40.0731 8.752C39.7691 8.64 39.4131 8.584 39.0051 8.584ZM48.6787 7.624H49.9867L51.7267 14.02L53.4667 7.6H54.8347L52.3987 16H51.0427L49.3027 9.592L47.5747 16H46.2307L43.8067 7.6H45.2347L46.9387 14.044L48.6787 7.624Z",
    fill: "#D0D0D0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 23,
    rx: 3.5,
    stroke: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBadge);
export default __webpack_public_path__ + "static/media/lowBadge.bdb6f9c61ab96f3681a6cf1fc7b6a3d5.svg";
export { ForwardRef as ReactComponent };